import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';

import { useCompanySettingsDraft } from './draft-context';

type VisibleSettingProps = {
  categoryId: string;
  settingKey: string;
  children: ReactNode;
  className?: string;
};

const VisibleSetting: FC<VisibleSettingProps> = ({
  categoryId,
  settingKey,
  children,
  className
}) => {
  const { isSettingVisible } = useCompanySettingsDraft();
  const isVisible = isSettingVisible(categoryId, settingKey);

  return (
    <div
      className={className}
      css={css`
        display: ${isVisible ? 'contents' : 'none'};
      `}
    >
      {children}
    </div>
  );
};

export default VisibleSetting;
